import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../../shared/shared.module';
import { EliminarAgendaMasivaComponent } from './eliminar-agenda-masiva.component';
import { EliminarAgendaMasivaRoutingModule } from './eliminar-agenda-masiva-routing.module';

@NgModule({
    declarations: [EliminarAgendaMasivaComponent],
    imports: [
        EliminarAgendaMasivaRoutingModule,
        SharedModule,
        CommonModule,

    ],
    entryComponents: []
})
export class EliminarAgendaMasivaModule { }
